import getConfig from "next/config";
const config = getConfig().publicRuntimeConfig;

/**
 * DEV, QA and STAGING should always use development ads, in google ad manager
 * the development ads are identified by the DEV_ prefix.
 */
export const ADS_PREFIX = config?.adsPrefix ?? "DEV_";

export const GTM_CONTAINER_ID = config?.GTMContainerId;

export const DFP_NETWORK_ID = config?.DFPNetworkId;

export const ADS_NAME = config?.adsName;